exports = module.exports = require("../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".container[data-v-42e1b428] {\n  position: relative;\n  height: 100%;\n  background: #fff;\n}\n.inner[data-v-42e1b428] {\n  position: relative;\n  background: #fff;\n  height: 100%;\n}\n.sidebar[data-v-42e1b428] {\n  position: absolute;\n  left: 0;\n  width: 200px;\n  padding: 1em 10px;\n  overflow: auto;\n  border-right: 5px solid #f5f5f5;\n  height: 100%;\n}\n.main[data-v-42e1b428] {\n  margin-left: 200px;\n  height: 100%;\n  overflow: auto;\n}\n", ""]);

// exports
